// extracted by extract-css-chunks-webpack-plugin
module.exports = {"link_container":"leader-award-units__link_container--1ZZqy","linkContainer":"leader-award-units__link_container--1ZZqy","label":"leader-award-units__label--3rsT2"};